
export function isMobile() {
  return window.innerWidth <= 768
}
export function shouldShowGameArea(vm) {
  // console.log(vm.isMobile, vm.isGameAreaVisible)
  return !vm.isMobile || vm.isGameAreaVisible
}
export function toggleGameArea(vm) {
  // console.log('toggleGameArea', vm.isGameAreaVisible)
  if (vm.isMobile) {
    vm.isGameAreaVisible = !vm.isGameAreaVisible
  }
  // console.log('return isGameAreaVisible', vm.isGameAreaVisible)
  return vm.isGameAreaVisible
  // 桌面板保持直接顯示
}
export function handleResize(vm) {
  vm.isMobile = window.innerWidth <= 768
  // console.log('return isGameAreaVisible', vm.isGameAreaVisible)
  if (!vm.isMobile) {
    vm.isGameAreaVisible = true
  }
}

let lastScrollY = 0

export function handleScroll(vm) {
  if (!vm.isMobile) return
  const currentScrollY = window.scrollY
  // console.log('window.scrollY', window.scrollY)
  const diff = currentScrollY - lastScrollY
  // console.log('diff', diff, 'current', currentScrollY, 'last', lastScrollY)
  // 往下滑（加閾值避免抖動）
  if (diff > 0 && currentScrollY > 0) {
    vm.isGameAreaVisible = false
  }
  // 往下滑
  if (diff > 0) {
    vm.isGameAreaVisible = false
  // 往上滑 or 回到頂部
  } else if (diff < 0 || currentScrollY === 0) {
    vm.isGameAreaVisible = true
  }
  lastScrollY = currentScrollY
}

export function counterObserver() {
  const observerOptions = {
    threshold: 0.5,
    rootMargin: '0px'
  }
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const statNumbers = entry.target.querySelectorAll('.stat-number')
        statNumbers.forEach(stat => {
          const target = parseFloat(stat.getAttribute('data-target'))
          const suffix = target === 99.9 ? '%' : target === 24 ? '24' : ''
          animateCounter(stat, target, suffix)
        })
        counterObserver.unobserve(entry.target)
      }
    })
  }, observerOptions)
  const statsSection = document.querySelector('.stats-section')
  if (statsSection) {
    counterObserver.observe(statsSection)
  }
}

function animateCounter(element, target, suffix = '') {
  let current = 0
  const increment = target / 100
  const duration = 2000
  const stepTime = duration / 100
  const timer = setInterval(() => {
    current += increment
    if (current >= target) {
      current = target
      clearInterval(timer)
    }
    if (suffix === '%') {
      element.textContent = current.toFixed(1) + suffix
    } else if (target >= 1000000) {
      element.textContent = (current / 1000000).toFixed(1) + 'M+'
    } else if (target >= 1000) {
      element.textContent = (current / 1000).toFixed(0) + 'K+'
    } else {
      element.textContent = Math.floor(current) + (suffix === '24' ? '/7' : '+')
    }
  }, stepTime)
}
